<template>
  <v-menu max-height="300" content-class="pa-0 ma-0" offset-y v-bind="$attrs">
    <template #activator="{ on, attrs }">
      <v-btn
        style="width: 100%;"
        elevation
        v-bind="{ ...attrs, ...attrsBtn }"
        v-on="on"
      >
        <slot v-if="$slots.prependIcon" name="prependIcon" />
        <v-icon class="mr-1" color="grey darken-1" v-else-if="prependIcon">
          {{ prependIcon }}
        </v-icon>
        {{ labelSelected }}
        <v-spacer />
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <section class="list_selectable">
      <template v-if="itemGroup">
        <SelectableGroup
          :groups="groups"
          v-model="selectedGroup"
          :is-all-items-selected="isAllItemsSelected"
          :is-some-items-selected="isSomeItemsSelected"
          @toggle="toggleAllItems"
        />
        <v-divider></v-divider>
      </template>
      <div
        v-for="item in groups[selectedGroup]"
        :key="item.value"
        class="item_selectable"
      >
        <SimpleCheckbox :item="item" v-model="selected" :multiple="multiple">
          <template #label>
            <slot v-if="$scopedSlots.item" name="item" :item="item" />
            <div class="label_item" v-else>
              <p class="ma-0 pa-0 text-body-1 text--primary">
                {{ item.text }}
              </p>
              <span class="text-caption text--secondary" v-if="itemGroup">
                {{ item.group }}
              </span>
            </div>
          </template>
        </SimpleCheckbox>
      </div>
    </section>
  </v-menu>
</template>
<script>
export default {
  name: "Selectable",
  props: {
    items: { type: Array, default: () => [] },
    value: { type: [Array, String], default: () => [] },
    multiple: { type: Boolean, default: false },
    label: { type: String, default: "Seleccionar" },
    prependIcon: String,
    itemText: String,
    itemValue: String,
    itemGroup: String,
    itemDisabled: String,
    size: String,
    variant: String,
    color: String
  },
  components: {
    SelectableGroup: () => import("./SelectableGroup.vue"),
    SimpleCheckbox: () => import("../SimpleCheckbox.vue")
  },
  data() {
    return {
      selectedGroup: "Todos"
    };
  },
  watch: {
    selectedGroup(newValue) {
      if (!newValue) this.selectedGroup = "Todos";
    }
  },
  computed: {
    labelSelected() {
      if (!this.selected) return this.label;
      const selected = this.getDataById(this.selected);
      if (selected.length === 0) return this.label;

      if (!this.multiple) return selected[0].text;
      if (selected.length === 1) return selected[0].text;
      return `${selected[0].text} (+${selected.length - 1}) seleccionados`;
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    itemsFormatted() {
      return this.items.map(item =>
        this.formatItem(
          item,
          this.itemText,
          this.itemValue,
          this.itemGroup,
          this.itemDisabled
        )
      );
    },
    groups() {
      if (!this.itemGroup) return { Todos: this.itemsFormatted };

      const groups = this.itemsFormatted.reduce((acc, item) => {
        const KEY = item.group || "Indefinido";

        if (!acc[KEY]) acc[KEY] = [];
        acc[KEY].push(item);

        return acc;
      }, {});

      return { Todos: this.itemsFormatted, ...groups };
    },
    attrsBtn() {
      const boolAttrs = ["size", "variant"];
      const attrs = boolAttrs.reduce((acc, key) => {
        const value = this[key];
        if (value) acc[value] = true;
        return acc;
      }, {});

      const valueAttrs = ["color"];
      const values = Object.fromEntries(
        valueAttrs.map(key => [key, this[key]])
      );

      return { ...attrs, ...values };
    },

    isSomeItemsSelected() {
      if (this.selectedGroup === "Todos") return this.selected.length > 0;

      const keysByGroup = this.groups[this.selectedGroup].map(i => i.value);
      const selectedByGroup = this.selected.filter(id =>
        keysByGroup.includes(id)
      );
      return selectedByGroup.length > 0;
    },
    isAllItemsSelected() {
      const itemsByGroup = this.groups[this.selectedGroup];
      if (this.selectedGroup === "Todos") {
        return this.selected.length === itemsByGroup.length;
      }

      const keysByGroup = itemsByGroup.map(i => i.value);
      const selectedByGroup = this.selected.filter(id =>
        keysByGroup.includes(id)
      );
      return selectedByGroup.length === keysByGroup.length;
    }
  },
  methods: {
    formatItem(
      item,
      keyText = "text",
      keyValue = "value",
      keyGroup = "group",
      keyDisabled = "disabled"
    ) {
      if (typeof item === "string") {
        return { text: item, value: item, disabled: false, group: null };
      }
      return {
        text: item[keyText],
        value: item[keyValue],
        group: item[keyGroup] || null,
        disabled: item[keyDisabled] || false
      };
    },
    getDataById(id) {
      const ids = Array.isArray(id) ? id : [id];
      return this.itemsFormatted.filter(item => ids.includes(item.value));
    },
    toggleAllItems() {
      const keysByGroup = this.groups[this.selectedGroup].map(i => i.value);
      if (this.isAllItemsSelected) {
        this.selected = this.selected.filter(id => !keysByGroup.includes(id));
      } else {
        this.selected = [...new Set([...this.selected, ...keysByGroup])];
      }
    }
  }
};
</script>

<style scoped>
.list_selectable {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  background-color: white;
  padding: 0.5rem;
}

.item_selectable {
  cursor: pointer;
  padding: 0.25rem;
}

.item_selectable:hover {
  background-color: #f5f5f5;
}

.label_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem;
}

.menu_list {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
}

.menu_list:hover {
  background-color: #f5f5f5;
}
</style>
